import React from 'react'
import styled, { keyframes } from 'styled-components'

const move = keyframes`
  0% {
    left: -30px;
    width: 30px;
  }
  50% {
    width: 70px;
  }
  100% {
    left: 230px;
  }
`
const Container = styled.div`
  height: 7px;
  width: 200px;
  background: lightgrey;
  position: relative;
  overflow: hidden;
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
`
const Bar = styled.div`
  background: #65B8C6;
  width: 30px;
  height: 7px;
  position: absolute;
  animation: ${move} 1s ease-in-out forwards infinite;
`

const Loader = props => {
  const { visible = true, className, barId } = props
  // Hide bar until loader is visible to start animation as soon as it is shown
  return (
    <Container visible={visible} className={className}>
      {visible && <Bar id={barId} />}
    </Container>
  )
}

export default Loader